document.addEventListener("DOMContentLoaded", () => {
  // Setup lightweight hardware-accelerated animations or adjustments here if needed.
  // Intersection Observer keeps background scaling updates clean and resource efficient.
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };

  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      const bgImg = entry.target.querySelector(".aeternum-bg-img");
      if (bgImg) {
        if (entry.isIntersecting) {
          bgImg.style.transform = "scale(1)";
        } else {
          bgImg.style.transform = "scale(1.05)";
        }
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersect, observerOptions);
  document.querySelectorAll(".aeternum-scroll-group").forEach((group) => {
    observer.observe(group);
  });
});
